/**
 * Stable CSS class names for E2E — MP bulk shipment update.
 */
export const MPBSU = {
    page: 'mp-bulk-shipment-update-page',
    shellPaper: 'mp-bulk-shipment-update-page__shell',
    breadcrumbSection: 'mp-bulk-shipment-update-page__breadcrumb-section',
    content: 'mp-bulk-shipment-update-page__content',
    typeField: 'mp-bulk-shipment-update-page__type-field',
    inputSelectUpdateType: 'mp-bulk-shipment-update-page-input--select-update-type',
    rulesPaper: 'mp-bulk-shipment-update-page__rules-paper',
    downloadWrap: 'mp-bulk-shipment-update-page__download-wrap',
    inputButtonDownloadTemplate: 'mp-bulk-shipment-update-page-input--button-download-template',
    uploadWrap: 'mp-bulk-shipment-update-page__upload-wrap',
    statusRow: 'mp-bulk-shipment-update-page__status-row',
    failedSection: 'mp-bulk-shipment-update-page__failed-section',
    failedTitle: 'mp-bulk-shipment-update-page__failed-title',
    failedGridWrap: 'mp-bulk-shipment-update-page__failed-grid-wrap',
} as const;
